import ChartContainer from "../../../components/general/widgets/chart";

const Chart = () => {
  return <ChartContainer />;
};

export default Chart;
